import { useState } from 'react';
import { FiltersMap, OptionalFiltersMap } from '@wix/bex-core';
import {
  CursorCollectionConfig,
  useWixPatternsContainer,
  useCreateCollection,
} from '@wix/bex-core/react';
import { CardsGridState } from '../state';

/**
 * @deprecated use useGrid instead
 */
export function useCursorGrid<T, F extends FiltersMap = OptionalFiltersMap>(
  config: CursorCollectionConfig<T, F>,
) {
  const createCollection = useCreateCollection();
  const container = useWixPatternsContainer();

  const [state] = useState(
    () =>
      new CardsGridState({
        collection: createCollection<T, F>({
          ...config,
          paginationMode: 'cursor',
        }),
        container,
      }),
  );

  return state;
}
